import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { ApiService, Indirizzo } from './api.service';
import { HeaderService } from './header.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "./header.service";
var MetodoSpedizione = /** @class */ (function () {
    function MetodoSpedizione() {
    }
    return MetodoSpedizione;
}());
export { MetodoSpedizione };
var FormIndirizzo = /** @class */ (function () {
    function FormIndirizzo() {
    }
    return FormIndirizzo;
}());
export { FormIndirizzo };
var StorageService = /** @class */ (function () {
    function StorageService(platformId, apiService, translate, header) {
        this.apiService = apiService;
        this.translate = translate;
        this.header = header;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    StorageService.prototype.set = function (key, value) {
        if (this.isBrowser) {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    };
    StorageService.prototype.get = function (key) {
        if (this.isBrowser) {
            return JSON.parse(sessionStorage.getItem(key));
        }
    };
    StorageService.prototype.setLocal = function (key, value) {
        if (this.isBrowser) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    };
    StorageService.prototype.getLocal = function (key) {
        if (this.isBrowser) {
            return JSON.parse(localStorage.getItem(key));
        }
    };
    /* ---------- */
    StorageService.prototype.getMappone = function (language) {
        if (this.isBrowser && this.get('superServizio_' + language)) {
            return of(this.get('superServizio_' + language));
        }
        else {
            return this.apiService.superServizio({ language: language });
        }
    };
    StorageService.prototype.getMapponeInLingua = function () {
        var language = this.translate.currentLang;
        if (!language) {
            return null;
        }
        return this.getMappone(language);
    };
    StorageService.prototype.getAbilitazioneCookie = function (cookie) {
        var permessi = this.getLocal('permessi');
        if (!permessi) {
            return false;
        }
        return permessi[cookie];
    };
    StorageService.prototype.setAbilitazioneCookie = function (cookie, abilitato) {
        var permessi = this.getLocal('permessi');
        if (!permessi) {
            permessi = {};
        }
        permessi[cookie] = abilitato;
        permessi.scadenza = new Date().setDate(new Date().getDate() + 30);
        this.setLocal('permessi', permessi);
    };
    StorageService.prototype.getCookiesScaduti = function () {
        var permessi = this.getLocal('permessi');
        if (!permessi || !permessi.scadenza) {
            return true;
        }
        return new Date() > permessi.scadenza;
    };
    /* INDIRIZZI  */
    StorageService.prototype.salvaIndirizzoUtente = function (indirizzo) {
        var _this = this;
        indirizzo['language'] = this.translate.currentLang.toUpperCase();
        return this.apiService.utenteRegistratoSaveIndirizzo(indirizzo).pipe(map(function (res) {
            if (res) {
                var user = _this.getLocal('user-stem');
                user.indirizzi = res.filter(function (i) { return i.enabled; });
                _this.setLocal('user-stem', user);
            }
            return res.filter(function (i) { return i.enabled; });
        }));
    };
    /* Spese spedizione */
    StorageService.prototype.getSpeseSpedizione = function () {
        var _this = this;
        if (this.isBrowser) {
            var cdLingua = this.translate.currentLang.toUpperCase();
            // const spese: Carrello = this.get('spese-spedizione');
            // if (spese) { return of(spese); }
            return this.apiService.getSpeseSpedizione({ cdLingua: cdLingua }).pipe(map(function (res) {
                _this.set('spese-spedizione', res);
                return res;
            }));
        }
    };
    /** @nocollapse */ StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.HeaderService)); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
